// Used to scope elements styles to the Elements library
export const ROOT_SELECTOR = "gram-elements";
